import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import axios from "axios"

const { Option } = Select 

/**
 * @const SelectVariante
 * @description Select para las variantes registrados en el sistema
 */
const SelectVariante = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Select variant", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        mode = null,
        labelInValue
    } = props

    const [ variantes, setVariante ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getVariantes
     * @description Obitiene los usaurios
     */
    const getVariantes = ({
        page, 
        limit, 
        search, 
    } = variantes) => {

        axios.get('/variantes', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setVariante(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error getting variants')
        })
    }

    //componentDidMount
    useEffect(() => {
        getVariantes()
    }, [params.producto_id])

    useEffect(() => {
        if (value)
            onChange(value?.value ?? value)
    }, [value])
    
    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getVariantes({search})}
            onSelect={(rubro)=> {
                if(mode === null && !labelInValue){
                    onChange(rubro.value)
                    onSelect(rubro.value)
                }
                if(mode === null && labelInValue){
                    onChange(rubro)
                    onSelect(rubro)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple" && !labelInValue){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }

                if(mode === "multiple" && labelInValue){
                    onChange(values)
                    onSelect(values)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                variantes?.data?.map(({ _id, nombre}) => <Option value={_id} key={_id}>{nombre ?? ""}</Option>)
            }
        </Select>
    );
}



export default SelectVariante;